// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__7HVYC","consentsList":"PatientConsents_consentsList__x257a","consentsListEmpty":"PatientConsents_consentsListEmpty__twmlr"};